import { Backend } from '@/_axios';

export default {
  GET_CLIENTS_LIST: function ({ commit }) {
    Backend.get('/api/all_clients').then((response) => {
      commit('SET_CLIENTS', response.data.data);
    }, (err) => {
      console.log(err);
    });
  },
  GET_CLIENTS_LIST_FILTERED: function ({ commit }, { search_value, pageNumber, pageSize }) {
    Backend.get('/api/clients_filtered', { params: { search_value: search_value, pageNumber: pageNumber, pageSize: pageSize } }).then((response) => {
      commit('SET_FILTERED_CLIENTS', response.data.data);
    }, (err) => {
      console.log(err);
    });
  },
  GET_CONTRACTS_LIST: function ({ commit }, { search_value, pageNumber, pageSize, document_type, client_name, contract_number }) {
    Backend.get('/api/all_contracts', { params: { search_value: search_value, pageNumber: pageNumber, pageSize: pageSize, document_type: document_type, client_name: client_name, contract_number: contract_number } }).then((response) => {
      commit('SET_CONTRACTS', response.data.data);
    }, (err) => {
      console.log(err);
    });
  },
  GET_INVOICES_LIST: function ({ commit }, val) {
    Backend.get('/api/all_invoices').then((response) => {
      commit('SET_INVOICES', response);
    }, (err) => {
      console.log(err);
    });
  },
  LOG_INVOICE_PAYMENT: function ({ commit }, { amount, invoiceId, paymentDate }) {
    Backend.patch('/api/invoice_paid', { amount: amount, invoiceId: invoiceId, paymentDate: paymentDate }).then((response) => {
      commit('SET_INVOICE', response);
    }, (err) => {
      console.log(err);
    });
  },
  SAVE_NEW_CLIENT: function ({ commit }, data) {
    return Backend.post('/api/new_client', data);
  },
  DELETE_CLIENT: function ({ commit }, id) {
    Backend.post('/api/delete_client', { id: id }).then((response) => {
      commit({ type: 'DELETE_CLIENT', id: id, message: response.data.data.message });
    }, (err) => {
      commit('ERROR_DELETE_CLIENT', err.response.data.data);
    });
  },
  UPDATE_CLIENT: function ({ commit }, data) {
    Backend.post('/api/update_client', data).then((response) => {
      commit({ type: 'UPDATE_CLIENT', data: data, message: response.data.data.message });
    }, (err) => {
      commit({ type: 'ERROR_UPDATE_CLIENT', message: err.response.data.data });
      console.log(err);
    });
  },
  SAVE_VARIABLES: function ({ commit }, data) {
    Backend.post('/api/save_variables', data).then((response) => {

    }, (err) => {
      console.log(err);
    });
  },
  SAVE_CONTRACT: function ({ commit }, data) {
    return Backend.post('/api/save_contract', { data: data });
  },
  UPDATE_CONTRACT: function ({ commit }, data) {
    return Backend.post('/api/update_contract', { data: data });
  },
  DELETE_CONTRACT: function ({ commit }, id) {
    Backend.post('/api/delete_contract', { id: id }).then((response) => {
      commit({ type: 'DELETE_CONTRACT', id: id, message: response.data.data.message });
    }, (err) => {
      commit({ type: 'ERROR_DELETE_CONTRACT', id: id, message: err.response.data.data.message });
      console.log(err);
    });
  },

  DELETE_VARIABLE: function ({ commit }, id) {
    Backend.post('/api/delete_variable', { id: id }).then((response) => {

    }, (err) => {
      console.log(err);
    });
  },
  DELETE_CALCULATION_ROW: function ({ commit }, id) {
    Backend.post('/api/delete_calculation_row', { id: id }).then((response) => {

    }, (err) => {
      console.log(err);
    });
  },
  COPY_CONTRACT: function ({ commit }, id) {
    Backend.post('/api/copy_contract', { id: id }).then((response) => {
      commit({ type: 'ADD_CONTRACT', data: response.data.data });
    }, (err) => {
      commit({ type: 'ERROR_COPY_CONTRACT', message: err.response.data.data.message });
    });
  },
  DELETE_FILE: function ({ commit }, id) {
    Backend.post('/api/delete_file', { id: id }).then((response) => {
      commit({ type: 'DELETE_FILE', id: id, message: response.data.data.message });
    }, (err) => {
      commit({ type: 'ERROR_DELETE_FILE', message: err.response.data.data.message });
    });
  },
  GET_CLIENT: function ({ commit }, id) {
    return Backend.get('/api/get_client', { params: { id: id } });
  },
  SEARCH_CLIENTS: function ({ commit }, text) {
    return Backend.get('/api/search_clients', { params: { text: text } });
  },
  SEARCH_CONTRACTS: function ({ commit }, text) {
    return Backend.get('/api/search_contracts', { params: { text: text } });
  },
  GET_LAST_INVOICE_NUMBER: function ({ commit }) {
    Backend.get('/api/get_last_invoice_number').then((response) => {
      commit('SET_LAST_INVOICE', response.data);
    }, (err) => {
      console.log(err);
    });
  },
  GET_ALL_CONTRACTS: function ({ commit }) {
    Backend.get('/api/get-all-contracts').then((response) => {
      commit('SET_ALL_CONTRACTS', response.data);
    }, (err) => {
      console.log(err);
    });
  }
};
